// (c) Copyright 2025 Hewlett Packard Enterprise Development LP

import { WebStorageStateStore } from "oidc-client"
import { AUTHORITY, CLIENT_ID, GREENLAKE_OAUTH_URL } from "./constants"

export function getOIDCConfig({
  workspaceId = undefined,
  useWorkspaceIssuer = false,
} = {}) {
  if (useWorkspaceIssuer && !workspaceId) {
    console.error("Workspace ID is required when using workspace oauth issuer")
  }

  const origin = window.location.origin
  const authorityURL = useWorkspaceIssuer
    ? `${GREENLAKE_OAUTH_URL}/authorization/v2/oauth2/${workspaceId}`
    : AUTHORITY

  return {
    authority: authorityURL,
    client_id: CLIENT_ID,
    redirect_uri: `${origin}/auth`,
    response_type: "code",
    post_logout_redirect_uri: origin,
    scope: "openid profile email",
    silent_redirect_uri: `${origin}/auth`,
    automaticSilentRenew: false,
    accessTokenExpiringNotificationTime: 300,
    loadUserInfo: false,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    metadataSeed: {
      // ping deviates from the standard (ping_end_session_endpoint)
      end_session_endpoint: useWorkspaceIssuer
        ? `${authorityURL}/logout`
        : `${authorityURL}/idp/startSLO.ping`,
    },
  }
}
